var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hbt-capa'),_c('hbt-livro'),_c('hbt-atalhos'),_c('hbt-sobre'),_c('hbt-treinamentos'),_c('hbt-treinamentos2'),_c('hbt-newsletter'),_c('hbt-servicos'),_c('hbt-terapeutas'),_c('hbt-blog'),_c('hbt-contato'),_c('hbt-rodape')],1)}
var staticRenderFns = []

export { render, staticRenderFns }